export default __webpack_public_path__ + "static/media/ltc.7be8b864.png";